import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  increment() { this.apply(this.currentValue + 1); }
  decrement() { this.apply(Math.max(0, this.currentValue - 1)); }
  change(event) { this.apply(Number(event.target.value) || 0); }

  apply(value) {
    this.inputTarget.value = value;
    const rows = document.querySelectorAll("[data-configurator-state-target='photoRow'][data-selected='true']");
    rows.forEach((row) => {
      row.dataset.quantity = String(value);
      const input = row.querySelector("[data-photo-quantity-target='input']");
      if (input) input.value = value;
    });
    this.dispatch("changed", { detail: { value }, bubbles: true, prefix: "bulk-quantity" });
  }

  get currentValue() {
    return Number(this.inputTarget.value) || 0;
  }
}
